<!--section 404 start-->
<div class="bg-blue">
  <div class="section-404">
    <div class="stars" [ngStyle]="{'background-image': 'url(assets/images/404/overlay_stars.svg)'}">
      <div class="">
        <div class="">
          <div class="">
            <div class="central-body">
              <h1 class="text-inner">404</h1>
              <h3 class="sub-text">{{ 'notFound.title' | translate }}</h3>
              <p class="text-404">{{ 'notFound.text' | translate }}</p>
              <button mat-stroked-button [routerLink]="['/']" class="btn btn-default primary-btn transparent m-t-20">{{ 'notFound.goHome' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="objects">
      <img alt="" class="object_rocket" src="assets/images/404/rocket.svg">
      <div class="earth-moon">
        <img alt="" class="object_earth" src="assets/images/404/earth.svg">
        <img alt="" class="object_moon" src="assets/images/404/moon.svg">
      </div>
      <div class="box_astronaut">
        <img alt="" class="object_astronaut" src="assets/images/404/astronaut.svg">
      </div>
    </div>
    <div class="glowing_stars">
      <div class="star"></div>
      <div class="star"></div>
      <div class="star"></div>
      <div class="star"></div>
      <div class="star"></div>
    </div>
  </div>
</div>
<!--section 404 end-->
